import { transformPromotedSpecialtiesForTopNavExp } from '../../../../../Homepage/transformPromotedSpecialtiesForTopNavExp';
import { useDesktopTopNav } from '../../../../Experiments/DesktopTopNavExperiment';
import { TELEHEALTH_SERVICES_LANDING_URL } from '../../../../constants';
import { useFetchedJson } from '../../../../services/NetworkService';
import { env } from '../../../../util/env';
import {
  Container,
  PillContainer,
  StyledSpecialtyPill,
  Title,
} from './EmptySearchSuggestions.styles';
import { SearchPromotionResponseValidator } from './SearchPromotionResponse.type';

interface Props {
  setValue: Setter<string>;
}

export const EmptySearchSuggestions = ({ setValue }: Props) => {
  const topNavExperiment = useDesktopTopNav();

  const fetched = useFetchedJson(
    `${env.MEGATRON_HOST}/api/4/search/promoted`,
    SearchPromotionResponseValidator,
  );

  if (!fetched.data) return null;

  const specialties = topNavExperiment
    ? transformPromotedSpecialtiesForTopNavExp(fetched.data.data)
    : fetched.data.data;

  return (
    <Container>
      <Title>Top specialties</Title>
      <PillContainer>
        {specialties.flatMap(item => {
          if (item.type === 'telehealth')
            return [
              <StyledSpecialtyPill
                key={item.title}
                name="GP Telehealth"
                logoPath={item.icon}
                url={TELEHEALTH_SERVICES_LANDING_URL}
                setValue={setValue}
                trackingId={`Search Bar Top Specialties - ${item.title}`}
              />,
            ];
          else if (item.type === 'specialty')
            return [
              <StyledSpecialtyPill
                key={item.title}
                name={item.title}
                topNavName={item.topNavTitle ?? undefined}
                logoPath={item.icon}
                setValue={setValue}
                trackingId={`Search Bar Top Specialties - ${item.title}`}
              />,
            ];
          else return [];
        })}
      </PillContainer>
    </Container>
  );
};
